/** Moves focus to `element` if it can be focused */
export default function focusElement(element) {
  if (!element || typeof element.focus !== 'function') {
    return;
  }

  element.focus();
}
